import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrolls the window to the top whenever the route pathname changes.
 *
 * Used inside `<BrowserRouter>` because the codebase does not use a data
 * router; React Router's built-in `<ScrollRestoration>` requires
 * `createBrowserRouter` and is therefore unavailable here.
 *
 * Renders nothing.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
